export default {
    data() {
        return {
            IVANHOE_URL: process.env.VUE_APP_IVANHOE_URL,
        }
    }
}